export class NetworkError extends Error {
    constructor(response) {
        super(response.statusText);
        this.status = response.status;
        this.response = response;
    }
}
//# sourceMappingURL=NetworkError.js.map